import { generateBackstageUrl } from './utils';

export const hrefFactoryForLegacyModules =
    (moduleName, externalPath) =>
    ({ selectedAccount: { id }, locale }) => {
        return generateBackstageUrl({
            accountId: id,
            componentPath: externalPath,
            locale,
            isQueryParamsEnabled: true,
        });
    };
